<div class="card">
	<div class="icon">
		<img [src]="'/assets/images/' + icon + '.svg'" />
	</div>
	<div class="head">
		<ng-container *ngIf="link"
			><a [href]="link" target="_blank" [interact]="{ engagementTypeID: 4, resource: link }">{{ displayHead }}</a></ng-container
		>
		<ng-container *ngIf="!link">{{ displayHead }}</ng-container>
	</div>
	<div class="body">{{ displayBody }}</div>
</div>
